import { blogAuthors } from "../../../mocks/blog";

export default function AuthorSpotlight() {
  return (
    <section className="py-16 bg-[#F8F8F8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-10">
          <span className="text-xs font-bold uppercase tracking-widest text-[#C9A227] mb-2 block">
            Meet the Team
          </span>
          <h2 className="text-2xl lg:text-3xl font-extrabold text-[#222831]">
            Written by Practitioners, Not Theorists
          </h2>
          <p className="mt-3 text-sm text-[#3A506B] max-w-xl mx-auto leading-relaxed">
            Every article on this hub is written by an active LTF Sourcing specialist
            with direct, on-the-ground experience in their domain.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
          {blogAuthors.map((author) => (
            <div
              key={author.name}
              className="flex flex-col items-center text-center p-5 rounded-xl bg-white border border-[#F0F2F5]"
            >
              {/* Avatar */}
              <div
                className={`w-14 h-14 flex items-center justify-center rounded-full ${author.bgColor} text-white text-base font-extrabold mb-3`}
              >
                {author.initials}
              </div>

              <h3 className="text-xs font-bold text-[#222831] leading-tight mb-1">{author.name}</h3>
              <p className="text-xs text-[#C9A227] font-semibold mb-2 leading-tight">{author.role}</p>
              <p className="text-xs text-[#3A506B]/70 leading-snug line-clamp-3">{author.bio}</p>

              <div className="mt-3 pt-3 border-t border-[#F0F2F5] w-full text-center">
                <span className="text-xs text-[#3A506B]/50">
                  <strong className="text-[#222831]">{author.articles}</strong> articles
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
